import {Grid, Typography} from '@mui/material';
import {Box} from '@mui/system';
import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
import {usePostApi} from 'common/hooks/usePostApi';
import {castToSend} from 'common/yup/castToSend';
import {onSubmitStub} from 'common/_stubs';
import AsyncContainer from 'components/AsyncContainer';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Dialog from 'components/Dialog';
import {Entry} from 'components/Entry';
import Formik from 'components/hook-form/Formik';
import FormikNumberField from 'components/inputs/FormikNumberField';
import FormikTextField from 'components/inputs/FormikTextField';
import {useToasts} from 'features/notifications/useToasts';
import {map} from 'lodash';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {ROISettingsLabels, ROISettingsSchema} from 'types/diplomat/settings/RoiSettings';

type Props = {
   // data: INav;
   onClose: () => void;
};
export const RoiSettingsDialog = ({onClose}: Props) => {
   const {t} = useTranslation();
   const {addToast} = useToasts();

   const {request, state: settings, loading} = useGetApi(api.roiSettings);
   const {request: saveSettings} = usePostApi(api.roiSettings, {
      onSuccess() {
         addToast(t('ROI settings saved successfully.'));
      },
   });

   useEffect(request, [request]);

   return (
      <Dialog header={t('ROI Settings')} close={onClose}>
         <AsyncContainer loading={loading}>
            <Formik
               initialValues={ROISettingsSchema.cast(settings)}
               onSubmit={(values) =>
                  saveSettings(JSON.stringify(castToSend(ROISettingsSchema, values)))
               }
               // enableReinitialize
            >
               <Box>
                  <Typography>{t('Specify the values to use in ROI calculations')}</Typography>
               </Box>
               <Grid container spacing={1}>
                  {map(ROISettingsLabels, (label, name) => (
                     <Entry
                        name={label}
                        value={
                           <FormikNumberField
                              name={name}
                              label={label !== ROISettingsLabels.hourlyRate ? 'minutes' : '$/hour'}
                           />
                        }
                        //   nameWidth={nameWidth}
                        //   nameMinWidth={nameMinWidth}
                     />
                  ))}
               </Grid>
               <FormFooterButtons cancel={onClose} />
            </Formik>
         </AsyncContainer>
      </Dialog>
   );
};
